import { AppPageLayout } from "@/components/common/AppPageLayout";
import { publicFormRoutePaddingClass } from "@/features/pages/components/formPageLayout";
import { selectFormByIdQueryOptions } from "@/features/forms/api/selectFormById";
import FormPage from "@/features/pages/components/TrackerFormPage";
import { createFileRoute } from "@tanstack/react-router";

// import useHandleNewEntry from "@/features/diary/entries/hooks/useHandleNewEntry";
const Page = () => {
    const { pageIndex } = Route.useParams();
    const { form } = Route.useLoaderData();

    return (
        <AppPageLayout width="md" padding="sm" className={publicFormRoutePaddingClass}>
            <FormPage pageIndex={Number(pageIndex)} form={form} route={Route} />
        </AppPageLayout>
    );
};

export const Route = createFileRoute("/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/")({
    component: Page,
    loader: async ({ context, params }) => {
        const form = await context?.queryClient.ensureQueryData(selectFormByIdQueryOptions(params.formId));
        return { form };
    },
});
